import Actions from '../../odata/actions';

const actions = new Actions('client', 'clients');

export default actions;
